import { ar } from './ar';
import { fr } from './fr';
import type { LanguageMode } from '../types/survey';

export { ar, fr };

export function getMessages(language: LanguageMode) {
  return language === 'ar' ? ar : fr;
}
